// extracted by mini-css-extract-plugin
module.exports = {"news-item-box":"Q","newsItemBox":"Q","img-box":"R","imgBox":"R","img-mask-box":"S","imgMaskBox":"S"};